// extracted by mini-css-extract-plugin
export default {"statistics_section":"style_statistics_section__tHHlP"};